import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { Endpoints } from '../../../api/Constants';
import { MISSIONS_ACTIONS } from '../../../screens/Missions/constants';
import missionsRewardsClaim from '../../../screens/Missions/utils/missionsRewards';
import { validateJson } from '../../../utils/jsonschema/validator';
import { missionRequestActionClaimReward, missionRequestActionStartMission, missionsRequestDataSuccess } from '../../slices/missions/missions';
import HTTP from '../../../utils/httpMethods';
import { getAssetsPackage } from '../assetsPackage';
import { handleQueryLoggerEvents } from '../../sagas/handleLoggerErrorEvents';
import { skipEventError } from '../../api/services/utils/validations';
var endpoint = Endpoints.MISSIONS_PLAYER;
export var getMissionsQuery = {
  query: function query(_ref) {
    var playerId = _ref.playerId;
    return {
      url: "".concat(endpoint, "/").concat(playerId)
    };
  },
  transformResponse: function transformResponse(response) {
    if (validateJson(endpoint, response)) return response.missionsFeatureState;
  },
  onQueryStarted: function () {
    var _onQueryStarted = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2, _ref3) {
      var _ref2$requestAssetsDa, requestAssetsData, dispatch, queryFulfilled, _yield$queryFulfilled, data, _error$error, _error$error$data;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _ref2$requestAssetsDa = _ref2.requestAssetsData, requestAssetsData = _ref2$requestAssetsDa === void 0 ? null : _ref2$requestAssetsDa;
              dispatch = _ref3.dispatch, queryFulfilled = _ref3.queryFulfilled;
              _context.prev = 2;
              _context.next = 5;
              return queryFulfilled;

            case 5:
              _yield$queryFulfilled = _context.sent;
              data = _yield$queryFulfilled.data;

              if (!requestAssetsData) {
                _context.next = 10;
                break;
              }

              _context.next = 10;
              return dispatch(getAssetsPackage.initiate({
                assetsPackageId: data.missionsFeature.assetsPackageId
              }));

            case 10:
              dispatch(missionsRequestDataSuccess(data));
              _context.next = 16;
              break;

            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](2);
              !skipEventError((_error$error = _context.t0.error) === null || _error$error === void 0 ? void 0 : (_error$error$data = _error$error.data) === null || _error$error$data === void 0 ? void 0 : _error$error$data.errorType) && handleQueryLoggerEvents(_context.t0);

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 13]]);
    }));

    function onQueryStarted(_x, _x2) {
      return _onQueryStarted.apply(this, arguments);
    }

    return onQueryStarted;
  }()
};
export var postMissionsMutation = {
  query: function query(_ref4) {
    var playerId = _ref4.playerId,
        action = _ref4.action,
        missionId = _ref4.missionId;
    return {
      url: "".concat(endpoint, "/").concat(playerId, "?action=").concat(action).concat(missionId ? "&missionId=".concat(missionId) : ''),
      method: 'post'
    };
  },
  keepUnusedDataFor: 0,
  transformResponse: function transformResponse(response) {
    if (validateJson(endpoint, response, HTTP.POST)) return response.missionsFeatureState;
  },
  onQueryStarted: function () {
    var _onQueryStarted2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref5, _ref6) {
      var action, dispatch, queryFulfilled, _yield$queryFulfilled2, data;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              action = _ref5.action;
              dispatch = _ref6.dispatch, queryFulfilled = _ref6.queryFulfilled;
              _context2.prev = 2;
              _context2.next = 5;
              return queryFulfilled;

            case 5:
              _yield$queryFulfilled2 = _context2.sent;
              data = _yield$queryFulfilled2.data;
              _context2.t0 = action;
              _context2.next = _context2.t0 === MISSIONS_ACTIONS.START_MISSION ? 10 : _context2.t0 === MISSIONS_ACTIONS.CLAIM_MISSION_REWARD ? 12 : 14;
              break;

            case 10:
              dispatch(missionRequestActionStartMission(data));
              return _context2.abrupt("break", 14);

            case 12:
              dispatch(missionRequestActionClaimReward(data));
              return _context2.abrupt("break", 14);

            case 14:
              if (data === null || data === void 0 ? void 0 : data.reward) missionsRewardsClaim(data === null || data === void 0 ? void 0 : data.reward);
              _context2.next = 20;
              break;

            case 17:
              _context2.prev = 17;
              _context2.t1 = _context2["catch"](2);
              handleQueryLoggerEvents(_context2.t1);

            case 20:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[2, 17]]);
    }));

    function onQueryStarted(_x3, _x4) {
      return _onQueryStarted2.apply(this, arguments);
    }

    return onQueryStarted;
  }()
};